import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSubheader } from "../../../../_metronic/layout";
import { Card } from "react-bootstrap";
import * as actions from "./_redux/LeadgerSummaryReportActions";
import { Link } from "@material-ui/core";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "./LeadgerSummaryReport.css";
import { imageUrl } from "../../../components/UIHelpers";

export default function LeadgerSummaryReport() {
  const { currentState } = useSelector((state) => ({
    currentState: state.addContests1,
  }));
  const { companyList } = currentState;
  const subheader = useSubheader();
  subheader.setTitle("Leadger Summary Report By Company");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [filteredCompanyList, setFilteredCompanyList] = useState([]);

  const viewCompanyCms = (code) => {
    console.log("Company Code:", code);

    let url;

    if (code === 'GJ') {
      url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}reports/LeadgerSummaryReportt/GJ`;
    } else if (code === 'Vi') {
      url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}reports/LeadgerSummaryReportt/VI`;
    } else if (code === 'D11') {
      url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}reports/LeadgerSummaryReportt/D11`;
    } else if (code === 'ME') {
      url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}reports/LeadgerSummaryReportt/ME`;
    } else {
      NotificationManager.error("This feature is not available for this company.", "Error");
      return;
    }

    window.open(url, "_blank");
  };

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await dispatch(actions.fetchCompanyList());
        console.log('Fetched Companies:', response); // Log response
        if (response && response.success && response.list) {
          // Retrieve user data from local storage
          const userData = JSON.parse(localStorage.getItem("userData"));
          console.log('User Data:', userData); // Log user data
          const userCompanies = userData?.company || [];

          // Filter companyList based on user's permission
          const filteredList = response.list.filter(company =>
            userCompanies.includes(company._id)
          );
          console.log('Filtered Companies:', filteredList); // Log filtered list

          setFilteredCompanyList(filteredList);
          setLoading(false);
        } else {
          NotificationManager.error("Failed to fetch companies.", "Error");
        }
      } catch (error) {
        NotificationManager.error(error.message, 'Error');
        setLoading(false);
      }
    };

    fetchCompanies();
  }, [dispatch]);

  return (
    <>
      <NotificationContainer />
      <div className="row">
        {loading ? (
          <div>Loading...</div>
        ) : (
          filteredCompanyList.map((company, index) => (
            <div key={index} className="form_grid_component col-lg-3 col-md-4 col-sm-6 col-6" style={{marginBottom:'2rem'}}>
              <div className="company-card-container w-100">
                <Link
                  onClick={() => viewCompanyCms(company.code)}
                  className="company-card-link"
                >
                  <Card className="company-card w-100">

                  {console.log("imageUrldd", imageUrl)}
                    <img
                      className="card-img"
                      src={`${imageUrl(company.logo?.default)}`}
                      alt={`${company.name}Logo`}
                    />
                    <div className="card-img-overlay">
                      <div className="card-bottom-title">
                        {company.name} 
                        
                      </div>
                    </div>
                  </Card>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}
